import { render } from "./notificationDropdown.vue?vue&type=template&id=2547470d&lang=pug"
import script from "./notificationDropdown.vue?vue&type=script&lang=js"
export * from "./notificationDropdown.vue?vue&type=script&lang=js"

import "./notificationDropdown.vue?vue&type=style&index=0&id=2547470d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__